import { type Writable, writable } from 'svelte/store';

export const allowedAdServedIds: Writable<string[]> = writable([]);

export function addAdServedId(id: string) {
	allowedAdServedIds.update((ids) => {
		// Make sure the ad ids are unique
		return [...new Set([...ids, id])];
	});
}

export function onAdServingMessage(event: MessageEvent) {
	const { data } = event.data;

	const adId = data.adId;

	addAdServedId(adId);
}

export function resetAdServedIds() {
	allowedAdServedIds.set([]);
}
